import React, { Component } from 'react'
import Slider from 'react-rangeslider'

// import styles
import './circleimage.scss'

import { isTouchDevice } from '../../../utils/detect'
import { translation } from '../../../utils/helpers'

// Elements
import Button from '../../elements/button'
import Icon from '../../elements/icon'
import { MarkImageIcons } from '../../elements/icons'

class CircleImage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      image: {},
      circles: [],
      mc: undefined,
      rotateCircles: false,
      oldImage: {},
      base64: '',
      circleimageModalWidth: 0,
      currentWidth: 0,
      currentHeight: 0,
      rotatedWidth: 0,
      rotatedHeight: 0,
      maxWidth: 0,
      isSubmit: false,
      sliderOpened: false
      // landscape: true
    }
    this.circleSize = this.circleSize.bind(this)
    this.addCircle = this.addCircle.bind(this)
    this.clearCircles = this.clearCircles.bind(this)
    this.rotateCircle = this.rotateCircle.bind(this)
    this.renderCircle = this.renderCircle.bind(this)
    this.submitImage = this.submitImage.bind(this)
    this.onCircleImageClose = this.onCircleImageClose.bind(this)
    this.hammerTime = this.hammerTime.bind(this)
    this.initHammer = this.initHammer.bind(this)
    this.destroyHammer = this.destroyHammer.bind(this)
    this.rotateCircleWithImage = this.rotateCircleWithImage.bind(this)
    this.screenRotation = this.screenRotation.bind(this)
    this.onOrientationChange = this.onOrientationChange.bind(this)
    this.setCurrentAndRotateSize = this.setCurrentAndRotateSize.bind(this)
    this.renderSlider = this.renderSlider.bind(this)
    // this.sliderHandleFix = this.sliderHandleFix.bind(this)
  }

  componentDidMount () {
    let image = this.props.image
    // to stop oldImage from updating with this.props.image
    let oldImage = {
      image: {
        ImageSize: {
          Height: image.image.ImageSize.Height,
          Width: image.image.ImageSize.Width
        },
        circles: [],
        file: image.image.file,
        imageUrl: image.image.imageUrl,
        rotation: image.image.rotation,
        base64: image.image.base64
      },
      index: image.index
    }

    // Listen for orientation changes
    window.addEventListener('orientationchange', this.onOrientationChange)

    let circleimageModalWidth = document.getElementsByClassName('modal__container')[0].getBoundingClientRect().width
    image.image.circles.map((circle, index) => {
      // circle.top = Math.floor((this.props.image.image.circles[index].top) * circleimageModalWidth / this.props.newOrderModalWidth) + 25
      // circle.left = Math.floor((this.props.image.image.circles[index].left) * circleimageModalWidth / this.props.newOrderModalWidth) + 25
    })

    this.setState({
      oldImage: oldImage,
      image: image,
      base64: image.image.imageUrl,
      circles: image.image.circles,
      circleimageModalWidth: circleimageModalWidth
    })

    let img = new window.Image()
    img.onload = () => {
      // set its dimension to rotated size
      this.setCurrentAndRotateSize(img.width, img.height)
    }
    img.src = this.props.image.image.base64
  }

  componentWillUnmount () {
    let image = {...this.state.image}
    image.image.ImageSize = {
      Width: parseInt(this.state.currentWidth),
      Height: parseInt(this.state.currentHeight)
    }
    this.destroyHammer()
    // this.props.submitImage(image, false)
    if (!this.state.isSubmit) {
      this.props.onCircleImageClose(this.state.oldImage, true)
    }

    window.removeEventListener('orientationchange', this.onOrientationChange)
  }

  componentDidUpdate () {
    let image = {...this.state.image}
    image.image.ImageSize = {
      Width: parseInt(this.state.currentWidth),
      Height: parseInt(this.state.currentHeight)
    }
    if (typeof this.state.mc === 'undefined') {
      this.initHammer()
    } else {
      this.hammerTime()
    }
  }

  setCurrentAndRotateSize (imageWidth, imageHeight) {
    let maxWidth = this.refs.image_wrap.getBoundingClientRect().width
    let currentWidth = imageWidth
    let currentHeight = imageHeight
    let rotatedWidth = imageHeight
    let rotatedHeight = imageWidth

    if (imageWidth >= maxWidth) {
      currentWidth = maxWidth
      currentHeight = imageHeight / imageWidth * maxWidth
    }

    if (imageHeight >= maxWidth) {
      rotatedWidth = maxWidth
      rotatedHeight = imageWidth / imageHeight * maxWidth
    }

    this.setState({
      currentWidth: currentWidth,
      currentHeight: currentHeight,
      rotatedWidth: rotatedWidth,
      rotatedHeight: rotatedHeight
    })
  }

  onOrientationChange () {
    setTimeout(() => {
      let oldWidth = this.state.currentWidth
      let oldHeight = this.state.currentHeight
      console.log('onOrientationChange', oldWidth, oldHeight)

      let img = new window.Image()
      img.onload = () => {
        // set its dimension to rotated size
        this.setCurrentAndRotateSize(img.width, img.height)
        // let landscape = img.width - img.height > 0
        this.screenRotation(oldWidth, oldHeight)
        this.setState({
          rotateCircles: false
          // landscape: landscape
        })
      }
      img.src = this.props.image.image.base64
    }, 500)
  }

  submitImage (e) {
    // e.preventDefault()
    let image = {...this.state.image}
    image.image.circles = this.state.circles
    image.image.circles.map((circle, index) => {
      circle.top = Math.floor(this.state.circles[index].top)
      circle.left = Math.floor(this.state.circles[index].left)
    })

    if (image.image.circles.length !== 0) {
      image.image.circles[image.image.circles.length - 1].active = false
    }

    image.image.ImageSize = {
      Width: parseInt(this.state.currentWidth),
      Height: parseInt(this.state.currentHeight)
    }

    this.setState({
      isSubmit: true
    })
    this.props.submitImage(image, true)
  }

  onCircleImageClose (e) {
    // e.preventDefault()
    this.props.onCircleImageClose(this.state.oldImage, true)
  }

  circleSize (size) {
    this.destroyHammer()
    let { circles } = this.state
    if (size) {
      if (circles[circles.length - 1].scale < 3) {
        circles[circles.length - 1].scale += 0.1
      }
    } else {
      if (circles[circles.length - 1].scale > 0.5) {
        circles[circles.length - 1].scale -= 0.1
      }
    }
    this.setState({
      mc: undefined,
      circles: circles
    })
  }

  addCircle () {
    if (typeof this.state.mc !== 'undefined') {
      this.destroyHammer()
    }
    let { circles } = this.state
    circles.map((val, index) => {
      val.active = false
      return val
    })
    circles.push({
      top: 0,
      left: 0,
      scale: 1,
      active: true
    })
    this.setState({
      mc: undefined,
      circles: circles,
      sliderOpened: true
    }, () => {
    })
  }

  clearCircles () {
    this.destroyHammer()
    this.setState({
      mc: undefined,
      circles: [],
      sliderOpened: false
    })
  }

  initHammer () {
    this.setState({
      mc: new window.Hammer.Manager(window.jQuery('#pnlDamagePhoto, .activemark')[0])
    })
  }

  destroyHammer () {
    if (typeof this.state.mc !== 'undefined') {
      this.state.mc.destroy()
    }
  }

  hammerTime () {
    if (this.state.circles.length === 0) return null
    let index = this.state.circles.length - 1
    let image = this.state.circles[index]

    let pan = new window.Hammer.Pan()
    this.state.mc.add(pan)
    let pinch = new window.Hammer.Pinch().recognizeWith(pan).set({ enable: true })
    // let pinch = new window.Hammer.Pinch()
    this.state.mc.add(pinch)

    let startTop = 0
    let startLeft = 0

    const getXandY = (event) => {
      let container = window.jQuery('#pnlDamagePhoto')
      let mark = window.jQuery('.activemark')
      let markWidth = mark.width()
      let markHeight = mark.height()
      let leftScaleModifier = 0
      let topScaleModifier = 0

      if (startTop === 0) {
        startTop = parseInt(mark.css('top'), 10)
      }
      if (startLeft === 0) {
        startLeft = parseInt(mark.css('left'), 10)
      }

      if (image.scale !== 1) {
        markWidth = markWidth * image.scale
        markHeight = markHeight * image.scale
        leftScaleModifier = (mark.width() - markWidth) / 2
        topScaleModifier = (mark.height() - markHeight) / 2
      }

      // Width bounds
      let x = null
      let leftBound = startLeft + event.deltaX + leftScaleModifier > 0
      let rightBound = startLeft + event.deltaX <= container.width() - markWidth - leftScaleModifier
      if (leftBound && rightBound) {
        x = event.deltaX + startLeft
      }

      // Height bounds
      let y = null
      let topBound = startTop + event.deltaY + topScaleModifier >= 0
      let bottomBound = startTop + event.deltaY <= container.height() - markHeight - topScaleModifier
      if (topBound && bottomBound) {
        y = event.deltaY + startTop
      }

      return {
        x: x,
        y: y
      }
    }

    this.state.mc.on('panmove', (event) => {
      let mark = window.jQuery('.activemark')
      let coordinates = getXandY(event)
      if (coordinates.x !== null) {
        mark.css('left', coordinates.x + 'px')
      }
      if (coordinates.y !== null) {
        mark.css('top', coordinates.y + 'px')
      }
    })

    this.state.mc.on('panend', (event) => {
      let { circles } = this.state
      let mark = window.jQuery('.activemark')
      circles[index].top = parseInt(mark.css('top'), 10)
      circles[index].left = parseInt(mark.css('left'), 10)
      this.destroyHammer()
      this.setState({
        mc: undefined,
        circles: circles
      })
    })

    this.state.mc.on('pinchin pinchout', (event) => {
      let mark = window.jQuery('.activemark')
      let scale = event.scale
      var transform = 'scale(' + scale + ')'
      mark.css('webkitTransform', transform)
    })

    this.state.mc.on('pinchend', (event) => {
      let { circles } = this.state
      let mark = window.jQuery('.activemark')
      let curTransform = new window.WebKitCSSMatrix(window.getComputedStyle(mark[0]).webkitTransform)
      circles[index].scale = parseInt(curTransform.a)
      if (circles[index].scale > 3) {
        circles[index].scale = 3
      } else if (circles[index].scale < 0.5) {
        circles[index].scale = 0.5
      }
      this.destroyHammer()
      this.setState({
        mc: undefined,
        circles: circles
      })
    })
  }

  rotateBase64 (base64Image) {
    return new Promise((resolve, reject) => {
      // create an off-screen canvas
      let offScreenCanvas = document.createElement('canvas')
      let offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // create Image
      let img = new window.Image()
      img.src = base64Image

      // on image load
      img.onload = () => {
        // set its dimension to rotated size
        offScreenCanvas.height = img.width
        offScreenCanvas.width = img.height

        // rotate and draw source image into the off-screen canvas:
        offScreenCanvasCtx.rotate(Math.PI / 2)
        offScreenCanvasCtx.translate(0, -offScreenCanvas.width)
        offScreenCanvasCtx.drawImage(img, 0, 0)

        // encode image to data-uri with base64
        resolve(offScreenCanvas.toDataURL('image/jpeg', 100))
      }

      // on image error
      img.onerror = (err) => {
        reject(err)
      }
    })
  }

  screenRotation (_oldWidth, _oldHeight) {
    let image = this.state.image
    if (image.image.ImageSize.Height !== 0) {
      let circles = this.state.circles
      circles.map((circle, index) => {
        let oldWidth = _oldWidth
        let oldHeight = _oldHeight
        let newTotalWidth = this.state.currentWidth
        let newTotalHeight = this.state.currentHeight
        console.log('screenRotation', oldWidth, oldHeight, this.state.currentWidth, this.state.currentHeight)

        let left = ((circle.left + 25) / oldWidth * newTotalWidth) - 25
        let top = ((circle.top + 25) / oldHeight * newTotalHeight) - 25
        circle.left = left
        circle.top = top
      })
    }
  }

  rotateCircleWithImage () {
    let image = this.state.image
    let oldWidth = this.state.currentWidth
    let oldHeight = this.state.currentHeight
    let newTotalWidth = this.state.rotatedWidth
    let newTotalHeight = this.state.rotatedHeight
    if (image.image.ImageSize.Height !== 0) {
      let circles = this.state.circles
      circles.map((circle, index) => {
        let oldPercentWidth = (circle.left + 25) / oldWidth * 100
        let newPercentHeight = (circle.top + 25) / oldHeight * 100
        let newPercentCircleWidth = 100 - newPercentHeight
        let newPercentCircleHeight = oldPercentWidth
        circle.left = (newTotalWidth * newPercentCircleWidth / 100) - 25
        circle.top = (newTotalHeight * newPercentCircleHeight / 100) - 25
      })
    }
    this.setState({
      rotateCircles: false,
      currentWidth: newTotalWidth,
      currentHeight: newTotalHeight,
      rotatedWidth: oldWidth,
      rotatedHeight: oldHeight
    })
  }

  rotateCircle () {
    let image = {...this.state.image}
    if (image.image.rotation === 3) {
      image.image.rotation = 0
    } else {
      image.image.rotation = image.image.rotation + 1
    }
    this.rotateBase64(image.image.base64).then((base64image) => {
      setTimeout(() => {
        this.rotateCircleWithImage()
      }, 1)
      image.image.ImageSize.Width = this.refs.circleImageItem.getBoundingClientRect().width
      image.image.ImageSize.Height = this.refs.circleImageItem.getBoundingClientRect().height
      image.image.base64 = base64image
      image.image.circles = this.state.circles
      this.setState({
        image: image,
        rotateCircles: true
      })
    }, () => {
      window.toastr.error(this.t('2233'), this.t('216'))
    })
  }

  renderCircle (circle, index) {
    let style = {
      WebkitTransform: 'scale(' + circle.scale + ')',
      top: circle.top + 'px',
      left: circle.left + 'px'
    }
    if (circle.active) {
      return (
        <div
          style={style}
          key={index}
          className='mark activemark' />
      )
    } else {
      return (
        <div
          style={style}
          key={index}
          className='mark inactivemark noselect'
          draggable='true' />
      )
    }
  }

  renderSlider () {
    if (this.state.circles.length === 0 || !this.state.sliderOpened) return null
    const onSlide = (size) => {
      let circles = this.state.circles
      if (circles[circles.length - 1].active) {
        circles[circles.length - 1].scale = size
        this.setState({
          circles: circles
        })
      }
    }
    return (
      <div className='sliderDiv'>
        <Slider
          min={0.5}
          max={3}
          step={0.1}
          value={this.state.circles[this.state.circles.length - 1].scale}
          orientation='vertical'
          reverse
          tooltip={false}
          onChange={onSlide}
        />
      </div>
    )
  }

  renderIcon (icon) {
    return (
      <Icon
        size='s'
        icon={icon}
        injectSvg
      />
    )
  }

  render () {
    let { image, circles } = this.state
    if (typeof image.image === 'undefined') return null
    // Drag image disable
    const onDragImage = (e) => {
      e.preventDefault()
      return false
    }
    // Rotation class
    let rotationClass = 'rotation-' + image.image.rotation

    let buttonSize = ''
    // if ((!this.state.sliderOpened) && !isTouchDevice()) buttonSize = 'newSize'

    let mobileClass = 'mobilePic'
    return (
      <div>
        {isTouchDevice() ? (
          <div className='touch'>
            <div className='four_buttons'>
              <Button onClick={this.rotateCircle} style='link' labelText={this.renderIcon(MarkImageIcons.Rotate)} size='m' />
              <div className='photodivider' />
              <Button onClick={this.addCircle} style='link' labelText={this.renderIcon(MarkImageIcons.Add_Phone)} size='m' />
              <Button onClick={this.clearCircles} style='link' labelText={this.renderIcon(MarkImageIcons.Delete)} size='m' />
              <div className='photodivider' />
              <Button onClick={this.submitImage} style='link' labelText={this.renderIcon(MarkImageIcons.Approve)} size='m' />
              <Button onClick={this.onCircleImageClose} style='link' labelText={this.renderIcon(MarkImageIcons.Close)} size='m' />
            </div>
            <div ref='image_wrap' className={'image_wrap ' + mobileClass}>
              <div id='pnlDamagePhoto' className={rotationClass} ref='pnlDamagePhoto'>
                <img id='circleImageItem' src={image.image.base64} ref='circleImageItem' className={'noselect ' + rotationClass} onDrag={onDragImage} onDragStart={onDragImage} draggable='false' />
                {circles.map(this.renderCircle)}
              </div>
            </div>
          </div>
        ) : (
          <div className={'circle__image addOrderPopup clearfix ' + rotationClass}>
            <div className={'four_buttons ' + buttonSize}>
              <Button onClick={this.rotateCircle} aria-label={this.t('15047')} style='link' labelText={this.renderIcon(MarkImageIcons.Rotate)} />
              <div className='photodivider' />
              <Button onClick={this.addCircle} aria-label={this.t('15048')} style='link' labelText={this.renderIcon(MarkImageIcons.Add_PC)} />
              <Button onClick={this.clearCircles} aria-label={this.t('15049')} style='link' labelText={this.renderIcon(MarkImageIcons.Delete)} />
              <div className='photodivider' />
              <Button onClick={this.submitImage} aria-label={this.t('15050')} style='link' labelText={this.renderIcon(MarkImageIcons.Approve)} />
            </div>
            <div className='circle__image__img-section'>
              {this.renderSlider()}
              <div ref='image_wrap' className='image_wrap'>
                <div id='pnlDamagePhoto' className={rotationClass} ref='pnlDamagePhoto'>
                  <img id='circleImageItem' src={image.image.base64} ref='circleImageItem' className={'noselect ' + rotationClass} onDrag={onDragImage} onDragStart={onDragImage} draggable='false' />
                  {circles.map(this.renderCircle)}
                </div>
              </div>
            </div>
          </div>
      )}
      </div>
    )
  }

  t (val) {
    if (typeof this.context !== undefined && typeof translation !== 'undefined') {
      return translation(val)
    }
    return this.props.t(val)
  }
}

export default CircleImage



// WEBPACK FOOTER //
// ./src/app/shared/components/CircleImage/index.js